export const audioRewindIcon = `
<svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19 12L10 6L19 0V12ZM9 12L0 6L9 0V12Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
